import { useQuery } from "@tanstack/react-query";
import brandCore from "../../core/brand.core";

export function BrandInventorySection({ brandId, warehouseId }: { brandId: string; warehouseId?: string }) {
  const {
    data: brandInventory,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["singleBrandInventory", brandId],
    queryFn: () => brandCore.getSingleBrandInventory(brandId),
  });

  if (error) return <div className="text-sm text-gray-500 dark:text-gray-400">-</div>;
  if (isLoading) return <span className="animate-spin rounded-full h-6 w-6 border-b-2 border-her-robinEggBlue mx-2"></span>;

  if (warehouseId) {
    const warehouseInventory = brandInventory?.inventories?.find((inv) => inv.warehouseId === warehouseId);
    if (warehouseInventory) {
      return (
        <div className="text-sm dark:text-white" data-warehouseId={warehouseId}>
          {warehouseInventory.count}
        </div>
      );
    }
    return (
      <div className="text-sm text-gray-500 dark:text-gray-400" data-warehouseId={warehouseId}>
        -
      </div>
    );
  }

  if (brandInventory && brandInventory?.inventories?.length > 0) {
    return (
      <div className="flex flex-wrap gap-4 flex-col">
        {brandInventory.inventories.map((warehouse) => (
          <div key={warehouse.warehouseId} className="flex flex-row justify-between gap-2">
            <p className="text-sm dark:text-white">{warehouse.warehouseName}</p>
            <p className="text-sm dark:text-white">{warehouse.count}</p>
          </div>
        ))}
      </div>
    );
  }

  return <div className="text-sm text-gray-500 dark:text-gray-400">-</div>;
}
